// --------------------------------------------------------------
// Created On: 2025-04-02
// Author: Hannah Vaughan
//
// Last Modified: 2025-04-02
// Modified By: Hannah Vaughan
//
// Copyright 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React from "react";
import PropTypes from "prop-types";
import styles from "./RemoteLockControls.module.scss";
import PanelSection from "../PanelSection/PanelSection";
import { BREAKPOINT_SMALL } from "src/constants/breakpoints";

// Container for the Remote Lock controls section in the Remote Operation Panel.
export default function RemoteLockControls(props: Props): Component {
  return (
    <PanelSection label="Remote Lock">
      <div className={`col px-3 ${styles.controlColumn}`}>
        {!props.isLockedOut && (
          <button
            className="btn btn-danger w-100"
            type="button"
            disabled={props.loading}
            onClick={() => props.onChangeLock(true)}
          >
            {props.windowDimensionWidth > BREAKPOINT_SMALL ? "Lock Remote Control" : "Lock"}
          </button>
        )}
      </div>
    </PanelSection>
  );
}

RemoteLockControls.propTypes = {
  isLockedOut: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  windowDimensionWidth: PropTypes.number.isRequired,
  onChangeLock: PropTypes.func.isRequired,
};

interface Props {
  isLockedOut: boolean;
  loading: boolean;
  windowDimensionWidth: number;
  onChangeLock: (isLocked: boolean) => void;
}
